import React from 'react';
import { ApiAppParams } from '@typings/apiApp';
import ReactDOM from 'react-dom/client';

import { EmbeddedPage } from '@/modules/embedded-page';

import { config } from './config';
import { isFrance, isPortugal } from './constants';
import desktopBg from './desktop-bg.jpeg';
import mobileBg from './mobile-bg.jpeg';

ReactDOM.createRoot(document.getElementById('saywhatt-page')!).render(
  <EmbeddedPage
    config={config as unknown as ApiAppParams}
    spinnerElement={document.querySelector('#saywhatt-loader')}
    desktopBg={desktopBg}
    mobileBg={mobileBg}
    promptLineBreaks={{
      desktop: !isFrance && !isPortugal ? 2 : null,
    }}
  />
);